"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outcomeHasParams = void 0;
const getOutcomeParameterValue_1 = require("./getOutcomeParameterValue");
// TODO Remove after PLAT-2815 release
const outcomeHasParams = (probWithOutcome, ...parameterTypes) => parameterTypes.every((parameterType) => (0, getOutcomeParameterValue_1.getOutcomeParameterValue)({
    eventProbability: probWithOutcome,
    parameterType,
}));
exports.outcomeHasParams = outcomeHasParams;
//# sourceMappingURL=outcomeHasParams.js.map